import { Textarea } from '@mantine/core';

import classes from './Textarea.module.css';

const TextareaDefaultProps = {
  radius: 'sm',
};

const TextareaDefaults = Textarea.extend({
  defaultProps: TextareaDefaultProps,
  classNames: {
    wrapper: classes.wrapper,
    input: classes.input,
  },
});

export { Textarea, TextareaDefaults };
